import { Icon24 } from 'builder/components/Icon'
import { navigate } from 'builder/modules/navigate'
import { SignUpCopyright } from '../SignUpCopyright'
import * as Styled from './styles'
import { trackInternalEvent } from '@rio/tracking'

type Props = React.HTMLAttributes<HTMLDivElement> & {
  onLogoClick?: () => void
  onCloseClick?: () => void
  controlsHidden?: boolean
  signInNewExperience?: boolean
}

export const SimpleLayout = ({
  onLogoClick = () => navigate('/'),
  onCloseClick,
  controlsHidden = false,
  signInNewExperience = false,
  children,
  ...rest
}: Props) => {

  const handleClose = () => {
    trackInternalEvent('click_exit_button', { location: 'sign_in_layout' })
    onCloseClick && onCloseClick()
  }

  
  return (
    <Styled.Container {...rest}>
      <Styled.Navbar>
        {!controlsHidden && <Styled.Logo onClick={onLogoClick} />}

        {!controlsHidden && onCloseClick && (
          <Styled.CloseButton aria-label="Close" onClick={handleClose}>
            <Icon24.CloseLarge />
          </Styled.CloseButton>
        )}
      </Styled.Navbar>

      <Styled.Content>{children}</Styled.Content>
      {signInNewExperience && <SignUpCopyright />}
    </Styled.Container>
  )
}
